<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t('message.hospitalization_type')"
    filterable
    clearable
 
  >
    <el-option v-for="item in typeHospitalizations" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['type_hospitalization_id'],
  mounted() {
    if (this.typeHospitalizations && this.typeHospitalizations.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    type_hospitalization_id:{
       handler: function (val, oldVal) { 
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    }
  },
  computed: {
    ...mapGetters({
      typeHospitalizations: 'typeHospitalizations/inventory',
    }),
  },
  methods: {
    ...mapActions({
      getInventory: 'typeHospitalizations/inventory',
    })
  },
};
</script>
